import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'
import { getStatus, onChange } from '@/platform/network'

/**
 * Thin banner shown above the app header when the device reports no
 * connectivity. We rely on `@/platform/network` for the cross-platform
 * branch — native builds go through `@capacitor/network`, web uses
 * `navigator.onLine`. React Query continues to serve cached reads
 * underneath; this banner is purely a hint.
 */
export function NetworkStatusBanner() {
  const [connected, setConnected] = useState<boolean>(true)

  useEffect(() => {
    let active = true
    void getStatus().then((s) => { if (active) setConnected(s.connected) })
    const unsub = onChange((s) => setConnected(s.connected))
    return () => {
      active = false
      unsub()
    }
  }, [])

  if (connected) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-xs font-medium text-amber-950 shadow"
      style={{ paddingTop: 'max(env(safe-area-inset-top), 0.375rem)' }}
    >
      <WifiOff className="h-3.5 w-3.5" aria-hidden="true" />
      <span>Offline — showing cached data</span>
    </div>
  )
}
